import React from 'react'
import injectSheet from 'react-jss'
import styles from './menu-item.styles'
import classNames from 'classnames'

const MenuItem = ({ classes, className, children, onClick, disabled }) => (
  <li
    onClick={disabled ? undefined : onClick}
    className={classNames(
      classes.menuItem,
      { [classes.disabled]: disabled },
      className
    )}>
    {children}
  </li>
)

export default injectSheet(styles)(MenuItem)
